import qs from 'qs';

export const updateQueryParams = (filters: any) => {
  if (filters && Object.keys(filters).length) {
    return window.history.replaceState(
      null,
      '',
      `${window.location.pathname}?${qs.stringify(filters, {
        arrayFormat: 'brackets',
      })}`,
    );
  }

  return window.history.replaceState(null, '', window.location.pathname);
};

export const getQueryParams = (location: any) => qs.parse((location.search || '').slice(1));
